import type { Plurals, Strings } from '../index';

export const strings: Strings = {
  'menu.home': 'Start',
  'menu.notes': 'Notities',
  'menu.reminders': 'Herinneringen',
  'menu.passwords': 'Wachtwoorden',
  'menu.cards': 'Kaarten',
  'menu.photoIds': 'Identiteitsbewijzen',
  'menu.collections': 'Collecties',
  'menu.conflicts': 'Conflicten ({count})',
  'menu.settings': 'Instellingen',
  'menu.lock': 'Wallet vergrendelen',
  'menu.language': 'Taal',

  'type.note': 'Notitie',
  'type.note.plural': 'Notities',
  'type.password': 'Wachtwoord',
  'type.password.plural': 'Wachtwoorden',
  'type.card': 'Kaart',
  'type.card.plural': 'Kaarten',
  'type.photoId': 'Identiteitsbewijs',
  'type.photoId.plural': 'Identiteitsbewijzen',

  'section.upcoming': 'Aankomende herinneringen',
  'section.pinned': 'Vastgezet',
  'section.recent': 'Recent',
  'section.searchResults': 'Zoekresultaten',
  'section.conflicts': 'Conflicten',

  'action.addNew': '+ Toevoegen',
  'action.back': 'Terug',
  'search.placeholder': 'Zoeken of toevoegen',

  'gate.title': 'Alles wat belangrijk is',
  'gate.copy': 'Je wallet wordt op dit apparaat versleuteld voordat er iets wordt gesynchroniseerd.',
  'gate.create': 'Nieuwe wallet aanmaken',
  'gate.open': 'Mijn bestaande wallet openen',
  'gate.recover': 'Toegang herstellen',

  'empty.addFirst': 'Voeg je eerste item toe.',
  'empty.nothingHere': 'Hier is nog niets.',
  'empty.noResults': 'Geen opgeslagen items komen overeen met die zoekopdracht.',

  'action.cancel': 'Annuleren',
  'action.save': 'Opslaan',
  'action.saving': 'Opslaan…',
  'action.close': 'Sluiten',
  'action.edit': 'Bewerken',
  'action.delete': 'Verwijderen',
  'action.remove': 'Verwijderen',
  'action.change': 'Wijzigen',
  'action.clear': 'Wissen',
  'action.add': 'Toevoegen',
  'action.show': 'Tonen',
  'action.hide': 'Verbergen',
  'action.more': 'Meer',

  'field.title': 'Titel',
  'field.body': 'Tekst',
  'field.username': 'Gebruikersnaam',
  'field.password': 'Wachtwoord',
  'field.website': 'Website',
  'field.notes': 'Notities',
  'field.cardNumber': 'Kaartnummer',
  'field.documentNumber': 'Documentnummer',
  'field.expiry': 'Geldig tot',
  'field.securityCode': 'Beveiligingscode',
  'field.cvv': 'CVV / CVC',
  'field.pin': 'Pincode',
  'field.documentType': 'Documenttype',
  'field.reminder': 'Herinnering',
  'field.collections': 'Collecties',
  'field.idPhotos': 'Foto’s van het document',
  'field.attachments': 'Bijlagen',

  'editor.newItem': 'Nieuw: {type}',
  'editor.editItem': '{type} bewerken',
  'editor.titlePlaceholder': 'Titel ({type})',
  'editor.selectDocumentType': 'Kies een documenttype',
  'editor.noneSelected': 'Niets geselecteerd',
  'editor.optional': 'Optioneel',
  'editor.optionalFields': 'Optionele velden',
  'editor.reminderDate': 'Datum van de herinnering',
  'editor.optionalTime': 'Tijd (optioneel)',
  'editor.shortcutHint': 'Ctrl+Enter slaat op. Esc annuleert.',
  'editor.addTitle': 'Voeg een titel toe.',
  'editor.saveFailed': 'Dit item kon niet worden opgeslagen.',
  'editor.photoFailed': 'Deze foto kon niet worden voorbereid.',
  'editor.attachmentFailed': 'Deze bijlage kon niet worden voorbereid.',
  'editor.photoNote': 'Foto’s tot {mb} MB worden versleuteld en op dit apparaat opgeslagen, en daarna automatisch gesynchroniseerd als synchronisatie aanstaat.',
  'editor.attachmentNote': 'Bestanden worden precies zo versleuteld als ze zijn gekozen en op dit apparaat opgeslagen. Safe Wallet blokkeert veelvoorkomende uitvoerbare bestanden, scripts, actieve webinhoud en bestanden met macro’s, maar scant bestanden niet op malware.',
  'editor.attachmentButton': 'Bijlage (max. {mb} MB)',
  'editor.addingAttachment': 'Bijlage toevoegen…',
  'editor.preparing': 'Voorbereiden…',
  'editor.takePhoto': 'Foto maken',
  'editor.choosePhoto': 'Foto kiezen',
  'editor.front': 'Voorkant',
  'editor.back': 'Achterkant',
  'editor.tapAddFront': 'Tik om de voorkant toe te voegen',
  'editor.tapAddBack': 'Tik om de achterkant toe te voegen',
  'editor.photoNotOnDevice': 'De versleutelde foto staat niet op dit apparaat.',
  'editor.pinItem': 'Vastzetten',
  'editor.pinned': 'Vastgezet',
  'editor.deleteItem': 'Item verwijderen',

  'viewer.noBody': 'Geen tekst.',
  'viewer.notSet': 'Niet ingevuld',
  'viewer.escCloses': 'Esc sluit deze weergave.',

  'attach.title': 'Bijlage',
  'attach.notOnDevice': 'De versleutelde bijlage staat nog niet op dit apparaat.',
  'attach.photoNotOnDevice': 'De versleutelde foto staat nog niet op dit apparaat.',
  'attach.openingPhoto': 'Versleutelde foto openen…',
  'attach.opening': 'Openen…',
  'attach.notStored': 'Niet op dit apparaat opgeslagen',
  'attach.couldNotOpen': 'Deze bijlage kon niet worden geopend.',
  'attach.previewUnavailable': 'Voor dit bestandstype is geen voorbeeld beschikbaar. Download het en open het met een app die je vertrouwt.',
  'attach.previewLimited': 'Voorbeeld beperkt tot de eerste 1 MB.',
  'attach.openPdf': 'PDF openen',
  'attach.download': 'Downloaden',

  'expiry.label': 'Geldig tot (MM/JJ)',
  'expiry.month': 'Maand',
  'expiry.chooseMonthYear': 'Kies maand en jaar',
  'expiry.chooseDate': 'Kies de vervaldatum',
  'expiry.previousYear': 'Vorig jaar',
  'expiry.nextYear': 'Volgend jaar',

  'collections.createFirst': 'Maak eerst collecties aan via het hoofdmenu.',
  'chooser.addNew': 'Toevoegen',

  'settings.title': 'Instellingen',
  'settings.account': 'Account',
  'settings.security': 'Beveiliging',
  'settings.recovery': 'Herstel',
  'settings.thisDevice': 'Dit apparaat',
  'settings.appearance': 'Weergave',
  'settings.searchPrivacy': 'Privacy bij zoeken',
  'settings.dangerZone': 'Gevarenzone',
  'settings.notSignedIn': 'Niet aangemeld',
  'settings.pinOnly': 'Alleen pincode',
  'settings.pinAndFingerprint': 'Pincode + vingerafdruk',
  'settings.changePinRow': 'Wijzig de pincode van de app op dit apparaat. Je huidige pincode is nodig.',
  'settings.lockNow': 'Nu vergrendelen',
  'settings.chooseAnotherWallet': 'Andere wallet kiezen',
  'settings.useAnotherAccount': 'Ander account gebruiken',
  'settings.categoryLabels': 'Categorielabels',
  'settings.rowSpacing': 'Regelafstand',
  'settings.textSize': 'Tekstgrootte',
  'settings.autoLock': 'Automatisch vergrendelen',
  'settings.optionName': 'Naam',
  'settings.optionIcon': 'Pictogram',
  'settings.optionBoth': 'Beide',
  'settings.optionLarge': 'Groot',
  'settings.optionMedium': 'Gemiddeld',
  'settings.optionCompact': 'Compact',
  'settings.optionSmall': 'Klein',
  'settings.searchPrivacyNote': 'De ontsleutelde zoekindex bestaat alleen op dit ontgrendelde apparaat en wordt gewist zodra de wallet vergrendelt. Wachtwoorden, pincodes, kaart- en rekeningnummers, beveiligingscodes, documentnummers, herstelcodes en vergelijkbare geheimen worden nooit geïndexeerd.',
  'settings.exampleProjection': 'Voorbeeld voor het eerste item',
  'settings.noItemsYet': 'Nog geen items.',
  'settings.removeWalletNote': 'Deze wallet uit deze browser verwijderen wist de versleutelde back-up in het account niet.',
  'settings.removeWallet': 'Deze lokale wallet verwijderen',

  'pin.changeTitle': 'Pincode van de app wijzigen',
  'pin.change': 'Pincode wijzigen',
  'pin.changing': 'Bezig met wijzigen…',
  'pin.current': 'Huidige pincode',
  'pin.new': 'Nieuwe pincode',
  'pin.repeat': 'Herhaal de nieuwe pincode',
  'pin.accountPassword': 'Accountwachtwoord',
  'pin.accountPasswordHint': 'Nodig om het aanmelden op je andere apparaten bij te werken.',
  'pin.noteSynced': 'Je opgeslagen items hoeven niet opnieuw te worden versleuteld. Omdat deze wallet synchroniseert, is je accountwachtwoord nodig zodat de nieuwe pincode ook werkt wanneer je je op een nieuw apparaat aanmeldt.',
  'pin.noteLocal': 'Je huidige pincode ontgrendelt deze wallet op dit apparaat. Je opgeslagen items hoeven niet opnieuw te worden versleuteld.',
  'pin.errCurrent': 'Voer je huidige pincode van 6 tot 12 cijfers in.',
  'pin.errNew': 'Gebruik een nieuwe pincode van 6 tot 12 cijfers.',
  'pin.errMismatch': 'De twee nieuwe pincodes komen niet overeen.',
  'pin.errSame': 'Kies een nieuwe pincode die verschilt van de huidige.',
  'pin.errPassword': 'Voer je accountwachtwoord in.',
  'pin.errFailed': 'De pincode van de app kon niet worden gewijzigd.',

  'fingerprint.title': 'Ontgrendelen met vingerafdruk',
  'fingerprint.settingUp': 'Instellen…',
  'fingerprint.unavailable': 'Dit apparaat kan dat niet.',
  'fingerprint.errOn': 'Dit kon niet worden ingeschakeld.',
  'fingerprint.errOff': 'Dit kon niet worden uitgeschakeld.',

  'sync.off': 'Uit — alleen op dit apparaat',
  'sync.notConfigured': 'Uit — synchronisatie niet ingesteld',
  'sync.connecting': 'Verbinden…',
  'sync.uploading': 'Aan — versleutelde back-up synchroniseren…',
  'sync.waiting': 'Aan — versleutelde wijzigingen wachten op verzenden',
  'sync.connected': 'Aan — versleutelde back-up verbonden',
  'sync.offline': 'Offline — versleutelde back-up gepauzeerd',

  'account.signedIn': 'Aangemeld',
  'account.signedInAs': 'Aangemeld als',
  'account.anotherAccount': 'Ander account',
  'account.currentAccount': 'Huidig account',
  'account.wallet': 'Wallet',
  'account.sync': 'Synchronisatie',
  'account.device': 'Apparaat',
  'account.signOut': 'Afmelden',
  'account.signOutOf': 'Afmelden bij {account}',
  'account.email': 'E-mail',
  'account.pinLabel': 'Safe Wallet-pincode',
  'account.pinHint': 'Je pincode voor deze wallet. Heeft dit account al een wallet, gebruik dan de pincode daarvan.',
  'account.pinPlaceholder': '6–12 cijfers',
  'account.signInTab': 'Aanmelden',
  'account.createTab': 'Account aanmaken',
  'account.forgotPassword': 'Accountwachtwoord vergeten?',
  'account.signInSync': 'Aanmelden en synchroniseren',
  'account.createSync': 'Account aanmaken en synchroniseren',
  'account.signInSyncTitle': 'Aanmelden en synchroniseren',
  'account.differentSession': 'In deze browser is een account aangemeld, maar deze lokale wallet is niet aan dat account gekoppeld. Open hieronder “Aanmelden en synchroniseren” om het account te koppelen waarvan deze wallet is, of meld je eerst af voor een ander account.',
  'account.notConfigured': 'Synchronisatie is niet ingesteld voor deze installatie.',
  'account.confirmEmail': 'Bevestig het account via je e-mail en meld je daarna hier aan. Deze lokale wallet is nog niet gekoppeld.',
  'account.errPin': 'Voer de Safe Wallet-pincode van 6 tot 12 cijfers voor deze wallet in.',
  'account.errSession': 'De accountsessie kon niet tot stand worden gebracht.',
  'account.connected': 'Wallet gekoppeld. De synchronisatie start.',
  'account.connectedNoSync': 'Account gekoppeld. Synchronisatie is niet beschikbaar in deze omgeving.',
  'account.errConnect': 'Dit account kon niet worden gekoppeld.',
  'account.resetSent': 'Controleer je e-mail voor de link om je wachtwoord opnieuw in te stellen.',
  'account.errReset': 'De e-mail om opnieuw in te stellen kon niet worden verzonden.',
  'account.signedOut': 'Afgemeld bij het account. De versleutelde wallet blijft op dit apparaat beschikbaar.',

  'pairing.advanced': 'Geavanceerd: een ander apparaat goedkeuren',
  'pairing.advancedNote': 'Gebruik dit alleen als het gewone aanmelden met wachtwoord en pincode niet mogelijk is. Vergelijk de vingerafdruk op beide apparaten voordat je goedkeurt.',
  'pairing.none': 'Geen apparaten in afwachting.',
  'pairing.invalidKey': 'Ongeldige koppelsleutel',
  'pairing.calculating': 'Vingerafdruk berekenen…',
  'pairing.review': 'Controleren',
  'pairing.reviewTitle': 'Nieuw apparaat controleren',
  'pairing.fingerprint': 'Controlevingerafdruk',
  'pairing.compare': 'Vergelijk elke groep met de vingerafdruk op het nieuwe apparaat.',
  'pairing.doNotApprove': 'Keur niet goed bij een verschil.',
  'pairing.mismatchNote': 'Dat kan betekenen dat de koppelsleutel is gewijzigd en dat de walletsleutel naar het verkeerde apparaat kan worden gestuurd.',
  'pairing.confirm': 'Ik heb beide vingerafdrukken vergeleken en ze komen exact overeen.',
  'pairing.approve': 'Apparaat goedkeuren',
  'pairing.approving': 'Goedkeuren…',
  'pairing.approved': '{device} goedgekeurd.',
  'pairing.errInvalid': 'Dit goedkeuringsverzoek bevat een ongeldige koppelsleutel. Wijs het af en start een nieuw verzoek.',
  'pairing.errChanged': 'De koppelsleutel is tijdens de controle gewijzigd. Annuleer dit verzoek.',
  'pairing.errApprove': 'Dat apparaat kon niet worden goedgekeurd.',

  'wallet.localOnly': 'Alleen lokale wallet',
  'wallet.lastUsedRecently': 'Onlangs gebruikt',
  'wallet.notConnected': 'Niet aan een account gekoppeld',
  'wallet.availableOnDevice': 'Wallet beschikbaar op dit apparaat',
  'wallet.onlyThisDevice': 'Alleen op dit apparaat — synchronisatie staat uit',

  'fingerprint.confirmBackup': 'Ontgrendelen met vingerafdruk inschakelen?\n\nDaarna heb je om deze wallet op dit apparaat te openen zowel je vingerafdruk als je pincode nodig. Werkt de vingerafdruk ooit niet meer, dan kom je er weer in met je back-upaanmelding of via een vertrouwd contact.',
  'fingerprint.confirmNoBackup': 'Ontgrendelen met vingerafdruk inschakelen?\n\nDaarna heb je om deze wallet op dit apparaat te openen zowel je vingerafdruk als je pincode nodig. Deze wallet heeft nog geen back-up, dus als de vingerafdruk ooit niet meer werkt, kan hij niet meer worden geopend. Het wordt sterk aangeraden eerst synchronisatie in te schakelen.',

  'gate.cloudNotConfigured': 'De cloud is nog niet ingesteld. Je kunt nu een lokale wallet aanmaken en die later koppelen via Instellingen.',

  'create.title': 'Pincode aanmaken',
  'create.intro': 'De pincode ontgrendelt dit apparaat. Je accountwachtwoord staat daar los van zodra je synchronisatie inschakelt.',
  'create.walletName': 'Naam van de wallet',
  'create.walletNameHint': 'Wordt in deze browser getoond vóór het invoeren van de pincode.',
  'create.walletNamePlaceholder': 'Alex, Sam, Gezinskluis…',
  'create.deviceName': 'Naam van het apparaat',
  'create.appPin': 'Pincode',
  'create.repeatPin': 'Herhaal de pincode',
  'create.creating': 'Aanmaken…',
  'create.createWallet': 'Wallet aanmaken',
  'create.errPin': 'Gebruik een pincode van 6 tot 12 cijfers.',
  'create.errMismatch': 'De twee pincodes komen niet overeen.',
  'create.errFailed': 'Deze wallet kon niet worden aangemaakt.',
  'create.errHello': 'Ontgrendelen met vingerafdruk kon niet worden ingeschakeld.',
  'create.fingerprintTitle': 'Vingerafdruk of gezicht toevoegen?',
  'create.fingerprintCopy': 'Een tweede slot, zodat een gestolen kopie van je wallet niet kan worden gekraakt. Je voert nog steeds je pincode in.',
  'create.turnOn': 'Inschakelen',
  'create.notNow': 'Niet nu',

  'unlock.title': 'Safe Wallet ontgrendelen',
  'unlock.unlock': 'Ontgrendelen',
  'unlock.opening': 'Openen…',
  'unlock.withFingerprint': 'Ontgrendelen met vingerafdruk',
  'unlock.wait': 'Wacht {seconds}s',
  'unlock.tooManyAttempts': 'Te veel pogingen. Probeer het over {seconds}s opnieuw.',
  'unlock.tooMany': 'Te veel onjuiste pincodes',
  'unlock.tooManyBackup': 'Neem even de tijd. Je kunt hieronder blijven proberen, of je toegang herstellen met je back-upaanmelding of een vertrouwd contact.',
  'unlock.tooManyLocal': 'Neem even de tijd en probeer het zorgvuldig opnieuw. Deze wallet staat alleen op dit apparaat, dus er is geen back-up om op terug te vallen.',
  'unlock.forgotPin': 'Safe Wallet-pincode vergeten?',
  'unlock.errFailed': 'Deze wallet kon niet worden geopend.',

  'chooser.chooseWallet': 'Kies een wallet',
  'chooser.eachHasPin': 'Elke opgeslagen wallet heeft in deze browser zijn eigen pincode.',
  'chooser.current': 'Huidige',
  'chooser.addAnother': 'Nog een account toevoegen',

  'existing.title': 'Bestaande wallet',
  'existing.heading': 'Mijn wallet openen',
  'existing.intro': 'Gebruik je accountwachtwoord en Safe Wallet-pincode om deze wallet op dit apparaat te openen.',
  'existing.openWallet': 'Wallet openen',
  'existing.forgotPin': 'Safe Wallet-pincode vergeten?',
  'existing.advanced': 'Geavanceerd: goedkeuren via een ander apparaat',
  'existing.advancedNote': 'Gebruik dit alleen voor oudere bètawallets die nog niet zijn bijgewerkt voor aanmelden met wachtwoord en pincode.',
  'existing.requesting': 'Aanvragen…',
  'existing.requestApproval': 'Goedkeuring van apparaat aanvragen',
  'existing.approvalTitle': 'Goedkeuring van apparaat',
  'existing.unavailable': 'Niet beschikbaar',
  'existing.calculating': 'Berekenen…',
  'existing.mismatchNote': 'Een verschil betekent dat de koppelsleutel onderweg gewijzigd kan zijn. Annuleer het verzoek en keur het niet goed.',
  'existing.cancelRequest': 'Verzoek annuleren',
  'existing.approved': 'Apparaat goedgekeurd',
  'existing.setPin': 'Stel een pincode in',
  'existing.setPinNote': 'Deze pincode beschermt de goedgekeurde walletsleutel op dit apparaat. Je mag dezelfde Safe Wallet-pincode gebruiken als op je andere persoonlijke apparaten.',
  'existing.finishing': 'Afronden…',
  'existing.errPin': 'Gebruik een Safe Wallet-pincode van 6 tot 12 cijfers.',
  'existing.errNoWallet': 'Dit account heeft nog geen Safe Wallet. Maak in plaats daarvan een nieuwe wallet aan.',
  'existing.errUpgrade': 'Een eenmalige upgrade is nodig. Open deze wallet één keer op een apparaat waar hij al werkt, schakel daar synchronisatie in en probeer het dan opnieuw.',
  'existing.errRequest': 'Goedkeuring van het apparaat kon niet worden aangevraagd.',
  'existing.errCancel': 'Het goedkeuringsverzoek kon niet worden geannuleerd; het verloopt automatisch.',
  'existing.errFinish': 'De goedkeuring van het apparaat kon niet worden afgerond.',
  'existing.errPairingInvalid': 'De lokale koppelsleutel is ongeldig. Annuleer en start een nieuw verzoek.',
  'existing.errCancelled': 'Dat goedkeuringsverzoek is geannuleerd. Start een nieuw verzoek.',
  'existing.errExpired': 'Dat goedkeuringsverzoek is verlopen. Start een nieuw verzoek.',

  'status.onDeviceOnly': 'Alleen op dit apparaat',
  'status.syncing': 'Synchroniseren…',
  'status.synced': 'Gesynchroniseerd',
  'status.offline': 'Offline',
  'status.saving': 'Opslaan…',
  'status.savingLocal': 'Opslaan op dit apparaat…',
  'status.openingDatabase': 'Lokale database openen…',
  'status.couldNotStart': 'Starten mislukt',
  'status.errInit': 'Safe Wallet kon niet worden gestart.',
  'status.errDatabase': 'De lokale database is niet gereed.',
  'menu.closeMenu': 'Menu sluiten',
  'action.showAll': 'Alles tonen',

  'conflict.collection': 'Collectie',
  'conflict.deletedVersion': 'Een verwijderde versie botst met een andere wijziging',
  'conflict.multipleChanges': 'Meerdere offline wijzigingen',
  'conflict.title': 'Conflict',
  'conflict.chooseVersion': 'Kies de versie die je wilt houden',
  'conflict.note': 'Beide versleutelde versies blijven bewaard tot je kiest. Een verwijderde versie kan bewust worden gekozen.',
  'conflict.loading': 'Versies laden…',
  'conflict.deleted': 'Verwijderde versie',
  'conflict.resolving': 'Oplossen…',
  'conflict.keepDeleted': 'Verwijderd houden',
  'conflict.useThis': 'Deze versie gebruiken',
  'conflict.errOpen': 'De conflicterende versies konden niet worden geopend.',
  'conflict.errResolve': 'Dit conflict kon niet worden opgelost.',
  'conflict.screenNote': 'Wijzigingen die offline op meerdere apparaten zijn gemaakt, blijven versleuteld bewaard tot je kiest welke versie je houdt.',
  'conflict.none': 'Geen conflicten.',

  'collections.newName': 'Naam van de nieuwe collectie',
  'collections.note': 'Collecties zijn privémappen. Een item kan tot meerdere collecties behoren.',
  'collections.confirmDelete': 'De collectie “{name}” verwijderen? De items blijven in Safe Wallet.',

  'item.confirmDelete': '“{title}” verwijderen? Het kan nog een beperkte tijd worden hersteld uit de back-upgeschiedenis.',
  'reminder.confirmDone': 'Deze herinnering als voltooid markeren?\n\nDe datum van de herinnering blijft op het item staan.',
  'reset.confirmOther': '“{name}” uit deze browser verwijderen? De versleutelde back-up in het account wordt niet gewist en je andere wallets in deze browser blijven ongemoeid. Je hebt het back-upaccount en de pincode nodig om hem hier weer toe te voegen.',
  'reset.confirmLast': 'Deze lokale wallet uit deze browser verwijderen? Versleutelde gegevens die al zijn gesynchroniseerd, worden niet uit het account gewist. Wijzigingen die nog moeten worden verzonden en de apparaatgoedkeuring van deze browser worden gewist.',

  'merge.confirmAdd': 'Dit account heeft al een wallet. Wil je je {items}, inclusief foto’s en bestanden, daaraan toevoegen en overschakelen?\n\nJe huidige wallet blijft in deze browser staan totdat je hem verwijdert.',
  'merge.notice': '{items} toegevoegd aan deze wallet, inclusief de bijbehorende foto’s en bestanden. Je oude wallet “{name}” staat nog in deze browser. Zodra de back-up is verzonden, kun je hem hieronder verwijderen.',
  'merge.removeOld': 'Oude wallet verwijderen',
  'merge.backingUp': 'Bezig met back-up…',
  'merge.dismiss': 'Sluiten',
  'merge.confirmRemoveOld': 'De oude wallet “{name}” uit deze browser verwijderen?\n\nDe items zijn al naar deze wallet gekopieerd en in je account geback-upt. Hiermee wordt alleen de oude lokale kopie in deze browser gewist.',
  'merge.errMismatch': 'De wallet die is geopend komt niet overeen met het account dat voor de kopie is gekozen. Er is niets uit de oorspronkelijke wallet verwijderd.',
  'merge.errOpenLocal': 'Open de lokale wallet voordat je de items ervan aan een andere wallet toevoegt.',
  'merge.errNoWallet': 'Dit account heeft geen wallet om items aan toe te voegen.',
  'merge.errKeyPackage': 'Open de wallet van het account één keer op het apparaat waar hij al werkt en probeer het dan opnieuw.',
  'merge.errPin': 'Die pincode opent niet de wallet die al op dit account staat. Voer de pincode van die wallet in.',

  'pin.errNoSync': 'Synchronisatie is niet ingesteld, dus de pincode kan niet worden bijgewerkt voor nieuwe apparaten.',
  'pin.errNoEmail': 'Voor deze wallet is op dit apparaat geen accountmailadres bekend.',
  'pin.errOffline': 'Je lijkt offline te zijn. Maak opnieuw verbinding om de pincode voor aanmelden op nieuwe apparaten te wijzigen.',
  'pin.errWrongPassword': 'Dat accountwachtwoord klopt niet.',
  'pin.errDeviceUnavailable': 'Dit apparaat is niet beschikbaar.',
  'pin.changedBoth': 'Pincode gewijzigd op dit apparaat en voor aanmelden op nieuwe apparaten.',
  'pin.changedLocal': 'Pincode gewijzigd. Gebruik de nieuwe pincode zodra dit apparaat weer vergrendelt.',

  'recover.accountTitle': 'Safe Wallet-account',
  'recover.passwordChanged': 'Wachtwoord gewijzigd',
  'recover.passwordChangedNote': 'Meld je opnieuw aan met het nieuwe accountwachtwoord. Je pincode en je versleutelde wallet zijn niet gewijzigd.',
  'recover.continue': 'Doorgaan',
  'recover.choosePassword': 'Kies een nieuw wachtwoord',
  'recover.choosePasswordNote': 'Dit wijzigt alleen het wachtwoord van het synchronisatieaccount. Je pincode blijft ongewijzigd en met dit wachtwoord alleen kun je je versleutelde wallet niet openen op een nieuw apparaat.',
  'recover.checkingLink': 'Herstellink controleren…',
  'recover.newPassword': 'Nieuw accountwachtwoord',
  'recover.repeatPassword': 'Herhaal het nieuwe wachtwoord',
  'recover.updating': 'Bijwerken…',
  'recover.updatePassword': 'Wachtwoord bijwerken',
  'recover.errShort': 'Gebruik minstens 8 tekens.',
  'recover.errMismatch': 'De twee wachtwoorden komen niet overeen.',
  'recover.errUpdate': 'Het accountwachtwoord kon niet worden bijgewerkt.',

  'recover.walletTitle': 'Wallet herstellen',
  'recover.freshVerification': 'Een wallet herstellen vraagt altijd om een nieuwe controle van je account. Safe Wallet vraagt een vertrouwd contact nooit om jouw code.',
  'recover.useOnlyWhen': 'Gebruik dit alleen als geen enkel eigen apparaat je pincode kan herstellen. Je hebt een nieuwe e-mailcontrole nodig en goedkeuring van één vertrouwd Safe Wallet-contact.',
  'recover.accountEmail': 'E-mailadres van het account',
  'recover.emailCode': 'Verificatiecode uit de e-mail',
  'recover.sendAnother': 'Nieuwe code versturen',
  'recover.authenticator': 'Authenticator',
  'recover.authenticatorCode': 'Authenticator-code',
  'recover.verifyStart': 'E-mail controleren en starten',
  'recover.verifyContinue': 'E-mail controleren en doorgaan',
  'recover.deviceFingerprint': 'Vingerafdruk van het herstellende apparaat',
  'recover.readFingerprint': 'Lees deze vingerafdruk voor aan je vertrouwde contact tijdens een live gesprek. Diegene moet jou bellen op contactgegevens die hij of zij al had — nooit op een nummer dat daarvoor is toegestuurd.',
  'recover.status': 'Status:',
  'recover.waitingEnds': 'Wachtperiode eindigt:',
  'recover.expires': 'Verloopt:',
  'recover.cancel': 'Herstel annuleren',
  'recover.setNewPin': 'Stel een nieuwe pincode in',
  'recover.keyRebuilt': 'Je walletsleutel is alleen in deze browser hersteld. De herstelbescherming is nu opgebruikt en moet opnieuw worden ingesteld.',
  'recover.deviceName': 'Naam van het apparaat',
  'recover.newPin': 'Nieuwe pincode',
  'recover.repeatPin': 'Herhaal de pincode',

  'invite.securityConfirmation': 'Beveiligingsbevestiging',
  'invite.title': 'Uitnodiging voor herstel',
  'invite.helpSomeone': 'Help iemand die je vertrouwt',
  'invite.invitedBy': 'Uitgenodigd door',
  'invite.askedYou': 'Deze persoon vraagt je om vertrouwd herstelcontact te zijn.',

  'invite.cannotSee': 'Je kunt hun wallet niet zien.',
  'invite.cannotSeeNote': 'Wat daarin is opgeslagen blijft versleuteld en privé.',
  'invite.cannotRecover': 'Je kunt hem niet zelf herstellen.',
  'invite.cannotRecoverNote': 'Je helpt pas nadat de eigenaar zelf het herstel is gestart.',
  'invite.nothingToRemember': 'Jij hoeft niets te onthouden.',
  'invite.nothingToRememberNote': 'Safe Wallet bereidt alles veilig voor zodra je accepteert.',
  'invite.enterPin': 'Voer je pincode in',
  'invite.confirming': 'Bevestigen…',
  'invite.decline': 'Weigeren',
  'invite.accept': 'Uitnodiging accepteren',
  'invite.confirmWithPin': 'Bevestig met je pincode',
  'invite.acceptTitle': 'Herstel-uitnodiging accepteren',
  'invite.confirmBecome': 'Bevestig dat je herstelcontact wilt worden voor:',
  'invite.declineTitle': 'Uitnodiging weigeren',
  'invite.declineQuestion': 'Toch geen herstelcontact worden?',
  'invite.invitationFrom': 'De uitnodiging van',
  'invite.keep': 'Uitnodiging bewaren',
  'invite.accepted': 'Uitnodiging geaccepteerd',
  'invite.nowContact': 'Je bent nu herstelcontact',
  'invite.nothingUnless': 'Je hoeft niets te doen, behalve als',
  'invite.inboxTitle': 'Herstel-uitnodigingen',
  'invite.review': 'Uitnodiging bekijken',
  'invite.errConfirm': 'Dit kon niet worden bevestigd.',
  'invite.errAccept': 'Deze uitnodiging kon niet worden geaccepteerd.',
  'invite.errDecline': 'Deze uitnodiging kon niet worden geweigerd.',

  'protect.preparing': 'Herstelbescherming voorbereiden…',
  'protect.addPerson': 'Een vertrouwd persoon toevoegen',
  'protect.addPersonNote': 'Een vertrouwd persoon kan je helpen weer in je wallet te komen. Diegene kan je wallet niet zien en hem niet zonder jou herstellen.',
  'protect.addSoYouCan': 'Voeg een vertrouwd persoon toe zodat je er weer in kunt als je je pincode of apparaat kwijtraakt.',
  'protect.mustHaveAccount': 'Diegene moet al een Safe Wallet-account hebben.',
  'protect.useTheirEmail': 'Gebruik het e-mailadres dat aan hun Safe Wallet is gekoppeld.',
  'protect.emailLabel': 'Safe Wallet-e-mail van de vertrouwde persoon',
  'protect.emailPlaceholder': 'naam@voorbeeld.nl',
  'protect.send': 'Uitnodiging versturen',
  'protect.yourPeople': 'Jouw vertrouwde personen',
  'protect.onlyYouSee': 'Alleen jij ziet deze lijst.',
  'protect.waiting': 'Wachten tot diegene accepteert',
  'protect.pending': 'In afwachting',
  'protect.canHelp': 'Kan helpen wanneer je om herstel vraagt',
  'protect.active': 'Actief',
  'protect.protectionActive': 'Herstelbescherming staat aan',
  'protect.becomesActive': 'De herstelbescherming gaat werken zodra één uitgenodigd persoon accepteert.',
  'protect.errLoad': 'De herstelbescherming kon niet worden geladen.',
  'protect.errSelf': 'Kies een andere Safe Wallet-gebruiker.',
  'protect.errNoAccount': 'Er is geen Safe Wallet-account gevonden voor dit e-mailadres. Vraag deze persoon eerst een account aan te maken en te bevestigen.',
  'protect.errNotReady': 'Dit Safe Wallet-account is nog niet klaar voor herstel-uitnodigingen. Vraag deze persoon om zijn of haar bijgewerkte Safe Wallet één keer te openen en te ontgrendelen en probeer het dan opnieuw.',
  'protect.errCheck': 'Dit Safe Wallet-account kon niet worden gecontroleerd.',
  'protect.errSend': 'Deze uitnodiging kon niet worden verstuurd.',
  'invite.willBeRemoved': 'wordt verwijderd. Diegene kan je later opnieuw uitnodigen.',
  'invite.asksForHelp': 'om hulp vraagt om weer in hun wallet te komen.',
  'protect.notSetUp': 'Niet ingesteld',
  'protect.checking': 'Controleren…',
  'reminder.done': 'Klaar',
  'reminder.doneOn': 'Klaar op {date}',
  'invite.enterWalletPin': 'Voer je Safe Wallet-pincode in',
  'invite.confirmInviteNote': 'Bevestig dat je deze persoon wilt uitnodigen als herstelcontact.',
  'invite.confirmInvite': 'Uitnodiging bevestigen',
  'recover.startTitle': 'Herstel starten',
  'recover.continueTitle': 'Herstel voortzetten',
  'invite.invitedYouTo': 'heeft je uitgenodigd als vertrouwd herstelcontact.',
  'approve.inboxTitle': 'Iemand heeft je hulp nodig',
  'approve.isRecovering': 'probeert weer in de eigen wallet te komen.',
  'approve.review': 'Verzoek bekijken',
  'approve.title': 'Toegang weer toestaan?',
  'approve.fingerprintLabel': 'Code op hun nieuwe apparaat',
  'approve.callFirst': 'Bel diegene eerst — op een nummer dat je al had, nooit op een nummer dat je is toegestuurd. Laat de code op hun scherm voorlezen en controleer of die precies met deze overeenkomt.',
  'approve.onlyIfSure': 'Keur alleen goed als de code overeenkomt en je zeker weet dat zij het echt zijn. Zo niet, laat het meteen weten zodat ze het verzoek kunnen annuleren.',
  'approve.approve': 'Codes komen overeen — goedkeuren',
  'approve.approving': 'Goedkeuren…',
  'approve.notNow': 'Niet nu',
  'approve.done': 'Goedgekeurd. Ze kunnen er nu weer in.',
  'approve.errApprove': 'Dit verzoek kon niet worden goedgekeurd.',
  'approve.waitUntil': 'Ze kunnen verder vanaf {time}.',
};

export const plurals: Plurals = {
  items: { one: '{count} item', other: '{count} items' },
  minutes: { one: '{count} minuut', other: '{count} minuten' },
  queued: { one: '{count} wijziging in wachtrij', other: '{count} wijzigingen in wachtrij' },
  helpers: { one: '{count} vertrouwd persoon kan helpen.', other: '{count} vertrouwde personen kunnen helpen.' },
};
